import React, {Fragment} from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import {DispatchContext, StateContext} from "../../containers/sidebarContext";
import {FaBeer, FaCoffee, FaGlassWhiskey, FaWineBottle, FaWineGlassAlt} from "react-icons/fa";
import {GiGlassShot} from "react-icons/gi";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const CoverBoxes = () => {
    const state = React.useContext(StateContext);
    const dispatch = React.useContext(DispatchContext);
    const { t } = useTranslation();

    function toggleSidebar(item){
        dispatch({ type: "activeSidebarItem", payload: item })
        dispatch({type: "toggleSidebar", payload: false});
        window.scrollTo(0, 0);
    }
    const sidebarItems = [
        {id: 1, title: t("sidebar:caffe"), link: "/kaffee", icon: <FaCoffee/>},
        {id: 2, title: t("sidebar:refreshing_drinks"), link: "/erfrischendeGetranke", icon: <GiGlassShot/>},
        {id: 3, title: t("sidebar:beer"), link: "/bier", icon: <FaBeer/>},
        {id: 4, title: t("sidebar:wine"), link: "/wine", icon: <FaWineGlassAlt/>},
        {id: 5, title: t("sidebar:alcohol"), link: "/alkohol", icon: <FaGlassWhiskey/>},
        {id: 6, title: t("sidebar:bottle_price"), link: "/flaschenpreise", icon: <FaWineBottle/>},
    ];

    return (
        <Fragment>
            <div className="cover-boxes">
                {sidebarItems.map((item) => (
                    <div
                        key={item.id}
                        className="cover-box"
                        onClick={() => toggleSidebar(item.title)}
                    >
                        <i className={
                            state.activeItem === item.title ? "active color-orange-light icon-size" : "color-yellow-light icon-size"

                        } aria-hidden="true">{item.icon}</i>
                        <Link
                            to={item.link}
                            data-toggle="collapse"
                            aria-expanded="false"
                        >
                            <em>{item.title} </em>
                        </Link>
                    </div>
                ))}
                <div className="clear"></div>
            </div>
        </Fragment>
    );
};

export default CoverBoxes;
